import { render } from "./TopUpLeads.vue?vue&type=template&id=1bc4ba2a&scoped=true&ts=true"
import script from "./TopUpLeads.vue?vue&type=script&lang=ts"
export * from "./TopUpLeads.vue?vue&type=script&lang=ts"

import "./TopUpLeads.vue?vue&type=style&index=0&id=1bc4ba2a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bc4ba2a"]])

export default __exports__